import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import { PERFORMANCE, performanceEnumTransKey } from '../enums';

import { Container } from '../styles';

const label = Object.values(PERFORMANCE);

const Performance = ({ isOpen, onClick, onApply, performance }) => {
  const [selectedItem, setSelectedItem] = useState(performance);

  useEffect(() => {
    if(performance?.length < 1) {
      setSelectedItem([]);
    }
  }, [performance]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter
      label="Performance"
      isOpen={isOpen}
      onClick={onClick}
      alignDropdownRight
    >
      <FilterForm
        label="Filtrar por performance"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={performanceEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  performance: state.tracking.filters.listPerformance,
});

export default connect(mapStateToProps)(Performance);
